import React from 'react';

import Copyright from 'lego-on-react/src/components/copyright/copyright.react';

import { useConfig } from 'client/common/hooks';

import 'lego-on-react/src/components/copyright/copyright.css';

export default function () {
    const { mordaHost } = useConfig();

    return <Copyright start={2014} url={mordaHost} />;
}
